export default __webpack_public_path__ + "static/media/14.c1c74e5b.jpg";